export function hasAuthenticatedSession(cookieValue, user, requireAdmin = false) {
    const hasIdentity = Boolean(user?.id_compte && user?.email);
    if (cookieValue !== 'true' || !hasIdentity) return false;
    return requireAdmin ? user.admin === true : user.admin !== true;
}
